import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const GenerateOrderMutation
 * @since 1.0.0
 */
export const GenerateOrderMutation = gql `
  mutation GenerateOrderMutation($input: GenerateOrderPDFInput!) {
    generateOrder(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
